import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const ActivityTitle: React.FC<ActivityTitleProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn('text-sm font-medium text-gray-900', className)}>
      {children}
    </div>
  );
};
